export interface StepItemProps {
  number: string
  title: string
  description: string
}

export const useStepItem = (props: StepItemProps) => {
  return {
    ...props,
  }
}
